import React from 'react';
import { Outlet } from 'react-router-dom';

const NotificationLayout: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  );
};

export default NotificationLayout;
